export const COIN_TYPE = {
  PEN: 1,
  USD: 2
}

export const COIN_TYPE_CODE = {
  [COIN_TYPE.PEN]: 'PEN',
  [COIN_TYPE.USD]: 'USD'
}

export const COIN_TYPE_NAME = {
  [COIN_TYPE.PEN]: 'SOLES',
  [COIN_TYPE.USD]: 'DOLARES'
}

export const COIN_TYPE_SYMBOL = {
  [COIN_TYPE.PEN]: 'S/',
  [COIN_TYPE.USD]: '$'
}

export const COIN_TYPE_OPTIONS = [
  {
    value: COIN_TYPE.PEN,
    label: COIN_TYPE_NAME[COIN_TYPE.PEN],
  },
  {
    value: COIN_TYPE.USD,
    label: COIN_TYPE_NAME[COIN_TYPE.USD],
  },
]
